'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem(text, icon) {
  this.iG = null;
  this.iF = null;
  this.iG = text;
  this.iF = icon;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem as $c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$TrioItem() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$TrioItem as $h_Lio_intela_sites_digitalinternship_data_Segments$TrioItem };
$h_Lio_intela_sites_digitalinternship_data_Segments$TrioItem.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 211484645, true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem) && ((this.iG === x$0.iG) && (this.iF === x$0.iF))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "TrioItem";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.iG;
  }
  if ((n === 1)) {
    return this.iF;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$TrioItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bL)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$TrioItem as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$TrioItem };
var $d_Lio_intela_sites_digitalinternship_data_Segments$TrioItem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$TrioItem, "io.intela.sites.digitalinternship.data.Segments$TrioItem", ({
  bL: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$TrioItem as $d_Lio_intela_sites_digitalinternship_data_Segments$TrioItem };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Trio-Item.js.map
